import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container min-vh-100 d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('labels.scanQrCode')), 1),
      _createVNode($setup["QrcodeVue"], {
        class: "m-4",
        value: $setup.qrValue,
        size: 300,
        level: "H"
      }, null, 8, ["value"])
    ])
  ]))
}